export const LoaderPending = () => {
  return (
    <section
      class='collection-explore'
      style={{ overflow: 'hidden', height: '50vh' }}
    >
      <div class=''>
        <div class='loading-spinner'>
          <img
            src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/exs-loader.svg`}
            alt='loader-logo'
          />
        </div>
      </div>
    </section>
  )
}
